import { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export default function ProductDetail() {
  const { t } = useTranslation();
  return <div>Not Route Found</div>;
}
